module.exports = __webpack_public_path__ + "static/media/PAHONV_MENU-normal.0bf1b4fd.png";